<script setup lang="ts">
import { StrapiBlocks, type BlocksContent } from "vue-strapi-blocks-renderer";
import Glide from "@glidejs/glide";

const route = useRoute();

useHead({
  title: `Post - ${route.params.slug}`,
});

const { data: post } = await useFetch<Post>(`/api/blog/posts/${route.params.slug}`);

const carousel = ref<Glide>(new Glide(".glide"));
const isCarouselFullview = ref(false);
const onClickImage = async (event: Event) => {
  isCarouselFullview.value = !isCarouselFullview.value;

  // carousel.value.destroy();
  // await nextTick();
  // // carousel.value.update();
  // carousel.value = new Glide(".glide");
  // carousel.value.mount();
  await nextTick();
  carousel.value.update();
};
onMounted(async () => {
  carousel.value.mount();

  // @ts-ignore
  // await import("slick-carousel");
  // const commonSlider = $(".single-post-slider");
  // commonSlider.slick({
  //   autoplay: false,
  //   dots: true,
  //   infinite: false,
  //   fade: false,
  //   speed: 300,
  //   slidesToShow: 1,
  //   adaptiveHeight: false,
  //   arrows: true,
  // });
});
</script>
<template>
  <div class="content">
    <Breadcumb :title="`Post - ${post?.title}`" :subtitle="'From the cloud of my thoughts.'" :items="[{ text: 'Blog', href: '/blog' }]" :to="{ text: 'Post Title', href: '' }" />
    <div class="xboot-standard-row gray-bg">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <!-- Start Single Post article -->
            <article class="single-post single-blog-post">
              <!-- <div class="post-thumbnail single-post-slider">
                <a v-for="image in post?.images" :href="composeImageUrl(image.url)" data-lightbox="img-gallery"><img :src="composeImageUrl(image.url)" :alt="image.name" /></a>
              </div> -->
              <div :class="{ 'carousel-fullview': isCarouselFullview, 'carousel-smallview': !isCarouselFullview }">
                <div class="glide" style="height: 100%">
                  <div class="glide__track" data-glide-el="track" style="height: 100%">
                    <ul class="glide__slides" style="height: 100%">
                      <li class="glide__slide" v-for="image in post?.images" :key="image.id" style="height: 100%">
                        <img @click="onClickImage" style="object-fit: contain; height: 100%; width: 100%" :src="composeImageUrl(image.url)" :alt="image.name" />
                      </li>
                    </ul>
                  </div>
                  <div v-if="post?.images && post?.images.length > 1" class="glide__arrows" data-glide-el="controls">
                    <button class="glide__arrow glide__arrow--left" data-glide-dir="<"><i class="ti-arrow-left"></i></button>
                    <button class="glide__arrow glide__arrow--right" data-glide-dir=">"><i class="ti-arrow-right"></i></button>
                  </div>
                </div>
              </div>

              <div class="single-post-content">
                <header class="single-post-header">
                  <h2 class="blog-post-title">{{ post?.title }}</h2>
                  <ul class="meta-info">
                    <li><NuxtLink to="/about-me">Met Devoti</NuxtLink></li>
                    <li>{{ new Date(post?.createdAt ?? 0).toLocaleDateString() }}</li>
                    <li>{{ post?.categoria?.title }}</li>
                  </ul>
                </header>
                <StrapiBlocks :content="post?.content || []" />

                <!-- <iframe v-if="post?.audio" v-for="(value, index) in post.audio" :key="index"
                  data-testid="embed-iframe"
                  style="border-radius: 12px"
                  :src="value.url"
                  width="100%"
                  height="352"
                  frameBorder="0"
                  allowfullscreen="false"
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  loading="lazy"
                ></iframe> -->

                <YouTubePlayer :url="post?.video?.[0]?.youtube ?? ''" />

                <footer class="single-post-footer">
                  <div class="post-shearing">
                    <!-- <ul>
                      <li>Share:</li>
                      <li>
                        <a href="#"><i class="fa fa-facebook"></i></a>
                      </li>
                      <li>
                        <a href="#"><i class="fa fa-twitter"></i></a>
                      </li>
                      <li>
                        <a href="#"><i class="fa fa-google-plus"></i></a>
                      </li>
                      <li>
                        <a href="#"><i class="fa fa-dribbble"></i></a>
                      </li>
                    </ul> -->
                  </div>
                  <div class="post-tags">
                    <ul>
                      <li style="color: var(--subtitle-color)">Tags:</li>
                      <li v-for="item in post?.tags" :key="item.id">
                        <a href="#">{{ item.tag }}</a>
                      </li>
                    </ul>
                  </div>
                </footer>
              </div>
            </article>
            <!-- End of single post article -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.carousel-smallview {
  height: 600px;
}
.carousel-fullview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background-color: black;
}

.meta-info li, .meta-info li a {
  color: var(--subtitle-color);
}
.post-tags li, .post-tags li a {
  color: var(--paragraph-color);
}
</style>
